export const PERMISSIONS = {
    ANALYTICS: 'analytics',
    SCHEDULER: 'scheduler',
    ADS: 'ads',
    DIRECT_MESSAGES: 'dm'
} as const;
